import type { ReactNode } from 'react'
import classNames from 'classnames'
import styles from './style.module.css'

export interface TabItem {
  id: string
  label: string
  content: ReactNode
}

interface TabsProps {
  items: TabItem[]
  activeId: string
  onChange: (id: string) => void
}

const Tabs = ({ activeId, items, onChange }: TabsProps) => {
  const active = items.find((item) => item.id === activeId) ?? items[0]

  return (
    <div className={styles.wrapper}>
      <div className={styles.tabList} role="tablist">
        {items.map((item) => (
          <button
            key={item.id}
            type="button"
            role="tab"
            aria-selected={item.id === active?.id}
            className={classNames(styles.tab, { [styles.tabActive]: item.id === active?.id })}
            onClick={() => onChange(item.id)}
          >
            {item.label}
          </button>
        ))}
      </div>

      <div className={styles.panel} role="tabpanel">
        {active?.content}
      </div>
    </div>
  )
}

export default Tabs
